<template>
  <div class="fillSpace">
    <AppMenu>
      <template v-slot:topleft>
        <div class="container-title">
          <RoundButton
            class="bordered back"
            href="/"
            :width="currentScreenWidth > 1024 ? 35 : 25"
            image="ic-arrow-back.svg"
          />
          <h2 class="page-title">
            <span class="page-title-text">{{
              getWebcontrol('ComprendreVotreVision-Titre-ComprendreVotreVision')
            }}</span>
          </h2>
        </div>
      </template>
      <template v-slot:bottomrightincontainer>
        <img class="logo-bottom-right" src="../assets/logo.png" />
      </template>
    </AppMenu>

    <div class="background">
      <div class="navigationPaneContainer" v-if="isLinksLoaded">
        <Pane>
          <UnderstandPane
            :title="getWebcontrol('ComprendreVotreVision-Titre-DefautsVisuels')"
            subtitle="subtitle"
            :category="getWebcontrol('ComprendreVotreVision-Titre-DefautsVisuels')"
            v-bind:links="getLinks('Défauts visuels')"
            image="ic-defauts-visuels.svg"
          />
        </Pane>
        <Pane>
          <UnderstandPane
            :title="getWebcontrol('ComprendreVotreVision-Titre-Sensibilisation')"
            subtitle="subtitle"
            :category="getWebcontrol('ComprendreVotreVision-Titre-Sensibilisation')"
            v-bind:links="getLinks('Sensibilisation')"
            image="ic-sensibilisation.svg"
            verticalAdjust="11"
          />
        </Pane>
      </div>
    </div>
  </div>
</template>

<script>
import AppMenu from '@Components/Menu.vue';
import RoundButton from '@Components/Menus/RoundButton.vue';
import Pane from '@Components/Pane.vue';
import UnderstandPane from '@Components/Panes/Understand.vue';
export default {
  components: {
    AppMenu,
    RoundButton,
    Pane,
    UnderstandPane,
  },
  computed: {
    currentScreenWidth() {
      return window.outerWidth;
    },
    isLinksLoaded() {
      return this.$store.getters.isVideoLoaded();
    },
  },
  methods: {
    getWebcontrol(key) {
      return this.$store.getters.getValueById(key);
    },
    getLinks(category) {
      let links = this.$store.getters.getVideoLinks(category);
      return links ? links : [];
    },
  },
  mounted() {
    this.$gtag.pageview({
      page_title: 'Comprendre votre vision',
      page_path: '/Comprendre votre vision',
      page_location: window.location.href,
    });
  },
};
</script>

<style scoped>
.fillSpace {
  width: 100%;
  height: 100%;
}
img.verre {
  position: absolute;
  left: -3%;
  top: -15%;
}
.container-title {
  display: -moz-flex;
  display: -webkit-flex;
  display: flex;
}
.page-title {
  padding-left: 20px;
  align-self: center;
}
.hStackable {
  max-height: 80%;
  margin: 20px;
  width: 100%;
  max-width: 320px;
}
.navigationPaneContainer {
  display: flex;
  width: 100%;
  /* height: 100%; */
  top: 7vh;
  bottom: 7vh;
  left: 50%;
  position: absolute;
  transform: translate(-50%, 0);
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.background {
  top: 10vh;
  bottom: 10vh;
  left: 7vw;
  right: 7vw;
  overflow: hidden;
  /* left: 50%; */
  position: absolute;
  /* transform: translate(-50%, -50%); */
  background-color: rgba(103, 103, 103, 0.08);
  background-image: url(../assets/vision.png);
  background-repeat: no-repeat;
  background-position: right 80px top 80px;
}
h2 {
  display: flex;
  justify-content: center;
  align-items: center;
}

/*
résolution moins de 1024
*/
@media (max-width: 1024px) {
  .navigationPaneContainer {
    display: flex;
    width: 100%;
    /* height: 100%; */
    top: 28px;
    bottom: 28px;
    left: 50%;
    position: absolute;
    transform: translate(-50%, 0);
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
}
.back:hover {
  border: 1px solid black;
}
</style>
